// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 169) return "static/js/LiveGamesContent.023bc2cbaa956fecdd77.chunk.js";
	if (chunkId === 707) return "static/js/CategoryDetails.83b0eac10eef1ff3a62a.chunk.js";
	if (chunkId === 225) return "static/js/MainNavigation.fd0fc4d57f577b6de6d4.chunk.js";
	if (chunkId === 597) return "static/js/BingoGames.8ce63cc2a7a0a9c5a4d5.chunk.js";
	if (chunkId === 237) return "static/js/GameDetails.041f10fb18c34e719911.chunk.js";
	if (chunkId === 112) return "static/js/GameDetailsContent.7d339ad2477a52b5c54c.chunk.js";
	if (chunkId === 455) return "static/js/SearchCategory.9a484ca61191c38dc5cd.chunk.js";
	if (chunkId === 94) return "static/js/SearchMoreResults.8d9a623777d482b8fc2f.chunk.js";
	if (chunkId === 86) return "static/js/SimplifiedHeader.51cdfb29507dab3bea43.chunk.js";
	if (chunkId === 660) return "static/js/SearchHeader.16811207823aff5ca1d6.chunk.js";
	if (chunkId === 265) return "static/js/SearchHistory.628832f183b52e2f0ef1.chunk.js";
	if (chunkId === 606) return "static/js/ErrorPage.c0d40374774894ccc70a.chunk.js";
	if (chunkId === 32) return "static/js/GameModal.33244349f17d99914b8c.chunk.js";
	if (chunkId === 700) return "static/js/Copy.36cb63752d10dab22a52.chunk.js";
	if (chunkId === 990) return "static/js/FloatingIcon.384f9a0f59dc6da0e8ab.chunk.js";
	if (chunkId === 620) return "static/js/ErrorContainer.a191e0058b6c66d79dc4.chunk.js";
	if (chunkId === 347) return "static/js/CookieBanner.78da7fdc6acc85d36a12.chunk.js";
	if (chunkId === 430) return "static/js/Menu.dd6ec441d9c7ae751d30.chunk.js";
	if (chunkId === 896) return "static/js/SearchWrapper.65d096dfc7657932bf5a.chunk.js";
	if (chunkId === 499) return "static/js/Download.3d29d21b414ad61b6177.chunk.js";
	if (chunkId === 410) return "static/js/SearchSuggestions.fb344a904e453b4d1f84.chunk.js";
	if (chunkId === 356) return "static/js/Steps.6221644c5ec2897093af.chunk.js";
	if (chunkId === 496) return "static/js/BannerStandalone.682319236cf74e9a297a.chunk.js";
	if (chunkId === 207) return "static/js/VideoModal.8d1e29bffefedeee590c.chunk.js";
	if (chunkId === 29) return "static/js/ProvidersFilter.7711a56b04adc5ed122e.chunk.js";
	if (chunkId === 401) return "static/js/IdlePopup.01c6bb0796fcfd67ffe2.chunk.js";
	if (chunkId === 152) return "static/js/JackpotDrawer.9be3224ce969015f0c1c.chunk.js";
	if (chunkId === 167) return "static/js/JackpotWidget.c34bf313f7b6e5154a89.chunk.js";
	if (chunkId === 899) return "static/js/GameBanner.0d2fde1147f1893f9d49.chunk.js";
	if (chunkId === 843) return "static/js/GameDual.b024a3a48ddd0bb9b8b3.chunk.js";
	if (chunkId === 349) return "static/js/GameList.c1f5ead5c9fa403dfaca.chunk.js";
	if (chunkId === 827) return "static/js/Grid.b150bb8f392013893546.chunk.js";
	if (chunkId === 160) return "static/js/ExtendedGrid.cdcabe5545047dce86b0.chunk.js";
	if (chunkId === 659) return "static/js/WidgetGrid.78b49907a5155ae77e49.chunk.js";
	if (chunkId === 737) return "static/js/GameGridSearch.58e76f4bf5138be18ef8.chunk.js";
	if (chunkId === 102) return "static/js/JackpotWidgetPrizeAreaDesktop.c58615168e3717516c7c.chunk.js";
	if (chunkId === 668) return "static/js/JackpotWidgetPrizeAreaMobile.50ed8f3af6555d722b0e.chunk.js";
	if (chunkId === 41) return "static/js/GameTileSearch.78e75ea98fee1a6bd63d.chunk.js";
	// return url for filenames based on template
	return undefined;
};